<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>KSeF - sprzedawcy</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li>
          <router-link to="/ksef/companies">KSeF - sprzedawcy</router-link>
        </li>
        <li class="active">
          <strong>Nowa</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <form @submit.prevent="createCompany" class="form-horizontal">
      <div class="row">
        <div class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <h5>KSeF - sprzedawcy</h5>
              <span class="ibox-toggle" @click="isMainOpen = !isMainOpen">
                <i :class="chevronMainClass"></i>
              </span>
            </div>
            <div class="ibox-content" v-show="isMainOpen">
              <div class="has-error" v-if="serverErrors.non_field_errors">
                <span
                  class="help-block"
                  v-for="(error, index) in serverErrors.non_field_errors"
                  :key="index"
                >
                  {{ error }}
                </span>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Nazwa *</label>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control inputClass"
                    v-model="companyObj.name"
                    @input="cleanErrors('name')"
                    required
                  />
                  <div class="has-error" v-if="serverErrors.name">
                    <span
                      class="help-block"
                      v-for="(error, index) in serverErrors.name"
                      :key="index"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">NIP *</label>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control inputClass"
                    v-model="companyObj.nip"
                    @input="cleanErrors('nip')"
                    required
                  />
                  <div class="has-error" v-if="serverErrors.nip">
                    <span
                      class="help-block"
                      v-for="(error, index) in serverErrors.nip"
                      :key="index"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <router-link to="/ksef/companies" class="btn btn-white">
                    Anuluj
                  </router-link>
                  <button
                    v-if="canAddCompany"
                    type="submit"
                    class="btn btn-primary"
                  >
                    Dodaj
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { ref, computed, watch } from "vue";
import { useStore } from "vuex";
import router from "../../router/router";
import { hasPermission } from "../../permissions";
import { ksefCompanyPermissionsConst } from "../../constants/ksefConstants";

export default {
  name: "KsefCompanyCreate",
  setup() {
    const store = useStore();
    const canAddCompany = computed(() =>
      hasPermission(ksefCompanyPermissionsConst.add)
    );
    const isMainOpen = ref(true);
    const companyObj = ref({
      name: "",
      nip: "",
    });
    const serverErrors = ref({});

    const chevronMainClass = computed(() =>
      isMainOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );

    const createKsefCompanyData = computed(
      () => store.getters.getCreateKsefCompanyData
    );

    const createCompany = () => {
      if (!canAddCompany.value) {
        return;
      }
      store.dispatch("createKsefCompany", companyObj.value);
    };

    const cleanErrors = (key) => {
      delete serverErrors.value[key];
    };

    watch(
      () => createKsefCompanyData.value,
      function (newValue) {
        if (newValue && newValue.status === 201) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Firma została dodana!",
          });
          router.push(`/ksef/companies/${newValue.data.pk}`);
        } else if (newValue && newValue.status && newValue.status !== 201) {
          serverErrors.value = newValue.data || {};
          var msg = [];
          if (newValue.data) {
            for (const [key, value] of Object.entries(newValue.data)) {
              msg.push(key + ": " + value);
            }
          }
          store.dispatch("showToaster", {
            type: "error",
            content:
              msg.length > 0
                ? msg[0]
                : "Wystąpił błąd podczas dodawania firmy!",
          });
        }
      }
    );

    return {
      canAddCompany,
      companyObj,
      serverErrors,
      createCompany,
      cleanErrors,
      isMainOpen,
      chevronMainClass,
    };
  },
};
</script>

<style scoped>
.ibox-title {
  position: relative;
}
.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 12px;
  cursor: pointer;
}
</style>
